export const defaultQuestionnaire = {
  familyHistory: {
    padre: { answer: null, details: '' },
    madre: { answer: null, details: '' },
    abuelos_paternos: { answer: null, details: '' },
    abuelos_maternos: { answer: null, details: '' }
  },
  pathological: {
    hipertension: { answer: null, details: '' },
    enfermedadesCorazon: { answer: null, details: '' },
    diabetes: { answer: null, details: '' },
    vih: { answer: null, details: '' },
    artritis: { answer: null, details: '' },
    convulsiones: { answer: null, details: '' },
    infartosMiocardio: { answer: null, details: '' },
    alergiaAnestesicos: { answer: null, details: '' },
    alergiaAntibioticos: { answer: null, details: '' },
    discrepanciasSanguineas: { answer: null, details: '' },
    enfViasRespiratorias: { answer: null, details: '' },
    hepatitis: { answer: null, details: '' },
    epilepsia: { answer: null, details: '' }
  },
  lifestyle: {
    bajoTratamientoMedico: { answer: null, details: '' },
    fuma: { answer: null, details: '' },
    consumeAlcohol: { answer: null, details: '' },
    consumeSustanciasPsicoactivas: { answer: null, details: '' },
    enjuagueBucal: { answer: null, details: '' },
    hiloDental: { answer: null, details: '' },
    embarazo: { answer: null, meses: '' },
    cancer: { answer: null, details: '' },
    bifosfonatos: { answer: null, details: '' },
    cirugiasPrevias: { answer: null, details: '' },
    otraEnfermedad: { answer: null, details: '' }
  },
  current: {
    padecimientoActual: '',
    ultimaConsultaOdontologica: ''
  }
};

export const mergeQuestionnaire = (loaded) => ({
  ...defaultQuestionnaire,
  ...(loaded || {}),
  familyHistory: { ...defaultQuestionnaire.familyHistory, ...((loaded || {}).familyHistory || {}) },
  pathological: { ...defaultQuestionnaire.pathological, ...((loaded || {}).pathological || {}) },
  lifestyle: { ...defaultQuestionnaire.lifestyle, ...((loaded || {}).lifestyle || {}) },
  current: { ...defaultQuestionnaire.current, ...((loaded || {}).current || {}) }
});
